module.exports = __webpack_public_path__ + "static/media/user-default-log.47be60ba.svg";